
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.737 14.322A5 5 0 017 11a1 1 0 10-2 0 7.001 7.001 0 006 6.93V20H9a1 1 0 100 2h6a1 1 0 100-2h-2v-2.07a6.985 6.985 0 004.153-2.192l-1.416-1.416zM18.3 14.055c.448-.923.7-1.96.7-3.055a1 1 0 10-2 0 5 5 0 01-.235 1.52l1.535 1.535z"}}),_c('path',{attrs:{"d":"M9 7.584V11a3 3 0 005.32 1.903L9 7.584zM15 10.756V5a3 3 0 00-5.99-.235l5.99 5.99z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.293 2.293a1 1 0 011.414 0l18 18a1 1 0 01-1.414 1.414l-18-18a1 1 0 010-1.414z"}})])
          )
        }
      }
    